<template>
  <el-card class="seedling">
    <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="考核大项" prop="assessmentType">
        <el-select v-model="formData.assessmentType" :disabled="!!scoreId" placeholder="请选择考核大项">
          <el-option v-for="item in assessmentTypeList" :key="item.dicCode" :label="item.dicValue"
            :value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考核细则编号" prop="scoreNo">
        <el-input v-model="formData.scoreNo" :disabled="!!scoreId" placeholder="请输入考核细则编号"></el-input>
      </el-form-item>
      <el-form-item label="考核内容及作业服务内容标准" prop="assessmentContent">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="formData.assessmentContent" placeholder="请输入考核内容及作业服务内容标准" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="扣分标准" prop="scoreStandard">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="formData.scoreStandard" placeholder="请输入扣分标准" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="扣分值" prop="score">
        <el-input v-model="formData.score" placeholder="请输入扣分值"></el-input>
      </el-form-item>
      <el-form-item class="ml20">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { oneDecimal } from '@/utils/validate'
export default {
  name: 'AssessmentRulesAdd',
  data() {
    return {
      assessmentTypeList: [],
      formData: {
        scoreNo: '', // 扣分编号
        assessmentType: '', // 考核项分类(字典assessmentType)
        assessmentContent: '', // 考核内容
        scoreStandard: '', // 扣分标准
        score: '' // 扣分值
      },
      rules: {
        assessmentType: [
          { required: true, message: '请选择考核大项' }
        ],
        scoreNo: [
          { required: true, message: '请输入考核细则编号' }
        ],
        assessmentContent: [
          { required: true, message: '请输入考核内容及作业服务内容标准' }
        ],
        score: [
          { validator: oneDecimal }
        ]
      },
    }
  },
  computed: {
    scoreId() {
      return this.$route.query.scoreId
    }
  },
  created() {
    if (this.scoreId) {
      this.loadData()
    }
    this.loadDict()
  },
  methods: {
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'assessmentType' }).then(res => {
        this.assessmentTypeList = res.assessmentType || []
      })
    },
    loadData() {
      this.$axios.get(this.$apis.assessmentScore.selectAssessmentScoreByScoreId, { scoreId: this.scoreId }).then(res => {
        this.formData = res || {}
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.scoreId ? this.$apis.assessmentScore.updateAssessmentScore : this.$apis.assessmentScore.insertAssessmentScore
          this.$axios.post(url, this.formData).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
